import { useRef, useState } from "react";
import styles from "./InputCode.module.scss";


export interface InputCodeProps {
  value?: string;
  onChange?: (value?: string) => void;
  nbcharacters?: number;
  groupCharacters?: number;
  emptyCharacter?: string;
  checkValue?: (value: string) => boolean;
  label?: string;
  isError?: boolean;
}
export default function InputCode({
  value = "",
  onChange,
  nbcharacters = 20,
  groupCharacters = 5,
  emptyCharacter = "*",
  checkValue,
  label,
  isError
}: InputCodeProps) {
  const valueArray = Array(nbcharacters).fill(emptyCharacter);

  const valueTab = value.split("");
  const inputRef = useRef<HTMLInputElement>(null);
  const [onFocus, setOnFocus] = useState(false);

  const onChangeValue = (newValue: string) => {
    if (checkValue && !checkValue(newValue)) {
      return;
    }

    newValue = newValue.replace(/[^a-zA-Z0-9]/g, ""); // Remove non-alphanumeric characters



    if (newValue.length > nbcharacters) {
      newValue = newValue.slice(0, nbcharacters);
    }
    onChange && onChange(newValue.toUpperCase());
  };

  return (
    <div>
      {label && (
        <p className={[styles["input-label"], onFocus ?styles["input-label--focus-on"]:styles["input-label--focus-off"], isError ? styles['input-label--error'] : "" ].join(" ")}>
          {label}
        </p>
      )}

      <div
        className={[
          styles["container-global-input"],
          onFocus
            ? styles["container-global-input--focus-on"]
            : styles["container-global-input--focus-off"],
            isError ? styles['container-global-input--error'] : "" 
        ].join(" ")}
        onClick={() => inputRef.current?.focus()}
      >
        <div
          className={[
            styles["container-global-input__value"],
            styles["input-value"],
            isError ? styles['input-value--error'] : "" 
          ].join(" ")}
        >
          {valueArray.map((char, index) => (
            <>
              <span
                key={index}
                className={[
                  styles["input-value__value-char"],
                  !valueTab[index]
                    ? styles["input-value__value-char--empty"]
                    : "",
                  onFocus
                    ? styles["input-value__value-char--focus-on"]
                    : styles["input-value__value-char--focus-off"],
                  isError ? styles['input-value__value-char--error'] : "" 
                ].join(" ")}
              >
                {valueTab[index] || emptyCharacter}{" "}
              </span>
              {(index + 1) % groupCharacters === 0 &&
                index !== valueArray.length - 1 && (
                  <div className={styles["input-value__separator"]}/>
                )}
            </>
          ))}
        </div>
        <input
          ref={inputRef}
          max={nbcharacters}
          onFocus={() => setOnFocus(true)}
          onBlur={() => setOnFocus(false)}
          className={[
            styles["container-global-input__input"],
            styles["input-text"],
          ].join(" ")}
          value={value}
          onChange={(e) => {
            onChangeValue(e.target.value);
          }}
          style={{ position: "absolute", opacity: 0,  left: "-9999999999px"}}
        />
      </div>
    </div>
  );
}




